import React from "react";
import Header, { HEADER_TYPE } from "components/ai-editor/sections/Header";
import Paragraph, { PARAGRAPH_TYPE } from "components/ai-editor/sections/Paragraph";
import { Alert } from "@mui/material";
import Markdown, { MARKDONW_TYPE } from "components/ai-editor/sections/Markdown";
import Image, { IMAGE_TYPE } from "components/ai-editor/sections/Image";
import AIBlock, { AI_TYPE } from "components/ai-editor/sections/AIBlock";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import TitleIcon from "@mui/icons-material/Title";
import SegmentIcon from "@mui/icons-material/Segment";
import AbcIcon from "@mui/icons-material/Abc";
import ImageIcon from "@mui/icons-material/Image";
import Note, { NOTE_TYPE } from "components/ai-editor/sections/Note"; 

export function getSectionIcon(type) {
  switch (type) {
    case HEADER_TYPE.key:
      return <TitleIcon />;
    case AI_TYPE.key:
      return <AutoAwesomeIcon />;
    case IMAGE_TYPE.key:
      return <ImageIcon />;
    case PARAGRAPH_TYPE.key:
      return <AbcIcon />;
    case MARKDONW_TYPE.key:
      return <SegmentIcon />;
    default:
      return null;
  }
}

function Section({ section, dragHandleProps }) {
  switch (section.type) {
    case IMAGE_TYPE.key:
      return <Image section={section} dragHandleProps={dragHandleProps} />;
    case MARKDONW_TYPE.key:
      return <Markdown section={section} dragHandleProps={dragHandleProps} />;
    case PARAGRAPH_TYPE.key:
      return <Paragraph section={section} dragHandleProps={dragHandleProps} />;
    case HEADER_TYPE.key:
      return <Header section={section} dragHandleProps={dragHandleProps} />;
    case AI_TYPE.key:
      return <AIBlock section={section} dragHandleProps={dragHandleProps} />;

    case NOTE_TYPE.key:
      return <Note section={section} dragHandleProps={dragHandleProps} />;
  }

  return <Alert severity="error">Unknown Type: {section.type}</Alert>;
}

function areEqual(prevProps, nextProps) {
  // Only re-render if section reference or content changed
  return (
    prevProps.section === nextProps.section ||
    JSON.stringify(prevProps.section) === JSON.stringify(nextProps.section)
  );
}

export default React.memo(Section, areEqual);
